<template>
	<div>
		<myheader headTitle="企业成员"></myheader>
		<div class="right all_height_line24 text14 textcolorwhite" @click="inviteMemberClick()">
			<img src="@/assets/images/add.svg" style="width:1.2rem;margin:.5rem;" />
		</div>
		<div class="all_list_main">
			<div style="padding: .3rem .5rem;background-color: white;">
				<div class="all_height_line20 flex" style="border-radius: 2rem;background-color: #f2f2f2;">
					<van-field class="text14 textcolor333 all_height_line20" v-model="keyword" maxlength="11"
						style="background-color: #f2f2f2;width: 80%;margin: 0 0 0 1rem;" placeholder="搜索姓名和账号" clearable
						@keydown.enter="onSearchMember()" />
					<img @click="onSearchMember()" src="@/assets/images/search_main.svg"
						style="height: 1.6rem;margin: .2rem .5rem;" />
				</div>
			</div>
			<div class="horizontal_line"></div>
			<div v-if="applyCount>0" class="flex backgroundC_white bwhite_ative" @click="jumpNewApply()"
				style="height: 3.2rem; padding: 0 .5rem;">
				<img src="@/assets/images/apply.svg" style="height:2.2rem;margin: .5rem 0;" />
				<span class="text14 textcolor333 font_weight_700 all_height_line16"
					style="display: inline-block;width:70%;margin: .8rem .5rem;">新的申请</span>
				<span class="text12 textcolor666 all_height_line14 all_text_center font_weight_bold"
					style="display: inline-block;width:1.4rem;background-color: #ccc;border-radius: 1rem;margin: 1rem 0;">{{applyCount}}</span>
			</div>
			<div v-if="applyCount>0" class="horizontal_line"></div>
			<div class="all_list_content_nopadding" :style="{top:applyCount>0?'9.9rem':'6.7rem'}">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div :style="{'min-height':applyCount>0?'68vh':'80vh'}">
						<!-- style="min-height: 68vh;" -->
						<div v-for="(item,index) in memberList" :key="index" v-show="memberList.length>0">
							<div class="flex backgroundC_white bwhite_ative" style="height: 3.2rem;padding: 0 .5rem;"
								@click="memberInfoClick(item)">
								<img src="@/assets/images/memberinfo.svg" style="height:2.2rem;margin: .5rem 0;" />
								<div style="display: inline-block;width:90%;margin: .5rem;">
									<div class="all_height_line12">
										<span
											class="memberName text14 textcolor333 font_weight_700">{{item.staffName}}</span>
										<span class="text12 textcolor999">{{item.userName}}</span>
									</div>
									<div class="all_height_line10">
										<span class="memberPower text8 textcolor999 font_weight_400"
											v-if="item.isSigner">签名人</span>
										<span class="memberPower text8 textcolor999 font_weight_400"
											v-if="item.isSealer">盖章人</span>
										<!-- <span
											class="memberPower text8 textcolor999 font_weight_400">{{item.staffTypeText}}</span> -->
									</div>
								</div>
							</div>
							<div class="horizontal_line"></div>
						</div>
						<van-empty style="margin-top: 15vh;" description="暂无数据" v-show="memberList.length==0" />
					</div>
				</van-pull-refresh>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,
		PullRefresh,
		Field
	} from "vant";
	export default {
		components: {
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[Field.name]: Field,
		},
		data() {
			return {
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				//
				canAdmin: '',
				//是否刷新
				refreshing: false,
				//申请加入数量
				applyCount: 0,
				//企业员工列表
				memberList: [],
				//搜索关键词
				keyword: ''
			}
		},
		methods: {
			//企业成员详情
			memberInfoClick(item) {
				this.$router.push({
					path: '/memberinfo',
					query: {
						//corpId: this.corpId,
						corpName: this.corpName,
						//staffId: item.staffId,
						staffCorpId: item.staffCorpId,
						canAdmin:this.canAdmin
					}
				})
			},
			//邀请同事
			inviteMemberClick() {
				this.$router.push({
					path: '/invitemember',
					query: {
						corpId: this.corpId,
						corpName: this.corpName
					}
				})
				// this.$router.push({
				// 	path: '/shareinvitemember',
				// 	query: {
				// 		corpId: this.corpId,
				// 		corpName: this.corpName
				// 	}
				// })
			},
			//跳转到新的申请页面
			jumpNewApply() {
				this.$router.push({
					path: '/newmemberapply',
					query: {
						corpId: this.corpId
					}
				})
			},
			//执行搜索
			onSearchMember() {
				// if (!this.keyword) {
				// 	this.$Toast('请输入姓名或手机号')
				// 	return
				// }
				this.getMemberList()
			},
			//下拉刷新
			onRefresh() {
				if (this.refreshing) {
					this.refreshing = false
				}
				this.getApplyCount()
				this.getMemberList()
			},
			//获取企业成员列表信息
			getMemberList() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/m/api/getMembers', {
					corpId: this.corpId,
					keyword: this.keyword
				}).then((res) => {
					this.refreshing = false
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.memberList = res.data
					} else {
						this.$Toast('获取成员失败！')
					}
				})
			},
			//获取申请人数
			getApplyCount() {
				this.$get('/corp/m/api/getNewJoinApplyCount', {
					corpId: this.corpId
				}).then((res) => {
					if (res.success && res.data) {
						this.applyCount = res.data
						//this.applyCount = 2
					}
				})
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.canAdmin = this.$route.query.canAdmin
				this.getApplyCount()
				this.getMemberList()
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.applyshow {
		min-height: 68vh;
	}

	.applynoshow {
		min-height: 80vh;
	}

	.right {
		position: fixed;
		top: 1.8rem;
		right: .5rem;
		z-index: 10;
	}

	.memberName {
		display: inline-block;
		width: 20%;
	}

	.memberPower {
		display: inline-block;
		width: 26%;
		background-color: #d7d7d7;
		margin-right: .5rem;
		border-radius: .5rem;
		text-align: center;
	}
</style>